import React, { FC } from 'react';
import styled from 'styled-components';


const Navigation = styled.div`
  padding: ${props => `${props.theme.spacing[2]} 0`};
  border-top: ${props => `1px solid ${props.theme.colors.shades[6]}`};
  text-align: center;
`;

const NavigationItem = styled.span<{
  current: boolean
}>`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 2px 0 3px;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${props => (props.current
    ? props.theme.colors.shades[3]
    : props.theme.colors.shades[5]
  )};
`;

NavigationItem.displayName = 'NavigationItem';

type Props = {
  numberOfNavigationItems: number,
  onNavigationItemClick: (index: number) => void,
  currentNavigationItemIndex?: number,
  className?: string
};

const CarouselNavigation: FC<Props> = ({
  numberOfNavigationItems, onNavigationItemClick, currentNavigationItemIndex = 0, className = undefined
}) => {

  const navigationItems = [];

  for (let i = 0; i < numberOfNavigationItems; i++) {
    navigationItems.push(
      <NavigationItem
        key={i}
        current={currentNavigationItemIndex === i}
        onClick={
          () => {
            onNavigationItemClick(i);
          }
        }
        data-name={`NavigationItem${i}`}
      />
    );
  }

  return (
    <Navigation className={className}>
      {navigationItems}
    </Navigation>
  );
};

CarouselNavigation.displayName = 'CarouselNavigation';


export default CarouselNavigation;
